import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BoxInterface } from "../../../model/box-interface";

class DataForBoxInterfaceCreation {
  boxInterface: BoxInterface = new BoxInterface();
  creatingFromBox?: boolean;
}

@Component({
  selector: 'aw-create-box-interface',
  templateUrl: './create-box-interface-dialog.component.html',
  styleUrls: ['./create-box-interface-dialog.component.scss']
})
export class CreateBoxInterfaceDialogComponent implements OnInit {

  creatingFromBox = false;
  returnThisInDialogClose?: boolean | BoxInterface;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DataForBoxInterfaceCreation,
    public dialogRef: MatDialogRef<CreateBoxInterfaceDialogComponent>,
  ) {


  }

  ngOnInit(): void {
    if (this.data.creatingFromBox)
      this.creatingFromBox = this.data.creatingFromBox;
    else
      this.returnThisInDialogClose = true;
  }
  returnBoxInterface(event: BoxInterface): void {
    this.returnThisInDialogClose = event;
  }

}


